import {
  Injectable,
} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthenticationService,
    private toastr: ToastrService,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Set user-key header based on request URL
    const isRefreshRequest = request.params.has('isRefresh') && request.params.get('isRefresh') === 'true';

    let updatedHeaders = isRefreshRequest
      ? request.headers.set('user-key', 'dae8fdadac6810f986b392dba096449b')
      : request.headers.set('user-key', 'e869285820cacedbb70e212dd4e3bb72');
  
    // Add Authorization Header if token exists
    const idToken = localStorage.getItem('id_token');
    if (idToken) {
      updatedHeaders = updatedHeaders.set('Authorization', `Bearer ${idToken}`);
    }

    // Clone the request with updated headers
    request = request.clone({ headers: updatedHeaders });

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && (error.status===403 || error.status === 0 || error.status === 401)) {
          return this.handle403Error(request, next);
        }
        return throwError(() => error);
      })
    );
  }

  private handle403Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.getRefreshtokenStorage().pipe(
      switchMap(() => {
        // Get the updated token after refresh
        const newIdToken = localStorage.getItem('id_token');
        if (newIdToken) {
          // Clone the request with the new token
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${newIdToken}`,
            },
          });
        }
        return next.handle(request);
      }),
      catchError((refreshError) => {
        console.error('Error refreshing token:', refreshError);
        this.handle401Error(); // Redirect to login if refresh fails
        return throwError(() => refreshError);
      })
    );
  }

  private handle401Error() {
    this.toastr.error(
      this.translate.instant('You are unauthorized to access this page'),
      // this.translate.instant('Please check your username and password')
    );
    localStorage.clear(); // Clear all user-related data
    this.router.navigate(['/login']);
  }
}
